import React from 'react';

import DisplayTypeCompanentG from './DisplayTypeCompanent/DisplayTypeCompanentG';
import DisplayTypeCompanentA from './DisplayTypeCompanent/DisplayTypeCompanentA';
import DisplayTypeCompanentF from './DisplayTypeCompanent/DisplayTypeCompanentF';
import DisplayTypeCompanentPrice from './DisplayTypeCompanent/DisplayTypeCompanentPrice';







const  CheckboxListFiltr=(props) => {
  

  switch (props.typeDisplay) {
    case 'F':
      return (
        <>
        <DisplayTypeCompanentF {...props} />
        </>
      );
      break;
    case 'A':
      return (
        <>
        < DisplayTypeCompanentA {...props} />
        </>
      );

      break;
    case 'G':

      return (
        <>
        <DisplayTypeCompanentG {...props} />
        <DisplayTypeCompanentPrice submitForm={props.submitForm}  setCheckenFiltr={props.setCheckenFiltr} name={"Цена"}  propertyValuePrice={props.getPriceSlide} propertyValuePriceMaxMin={props.getPriceSlideMaxMin} code={"price"}  checked={props.checked}  />
        </>
      );

      break;
    default:
      return (
        <>
        </>
      );
  }

}


export default CheckboxListFiltr;